import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { HelpCenterPage as LegacyHelpCenterPage } from "../HelpCenter/Page";
import { HELP_CENTER_PATH } from "../HelpCenter/paths";
import { NotFoundPage } from "../lib";
import { useIsHelpCenterRedesignEnabled } from "../redesign/HelpCenter/hooks/useIsHelpCenterRedesignEnabled";
import { HelpCenterPage as RedesignedHelpCenterPage } from "../redesign/HelpCenter/Page";

function HelpCenterRoute() {
  const isHelpCenterRedesignEnabled = useIsHelpCenterRedesignEnabled();

  if (isHelpCenterRedesignEnabled) {
    return <RedesignedHelpCenterPage />;
  }

  return <LegacyHelpCenterPage />;
}

export function AppV2PrivateRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${HELP_CENTER_PATH}`}>
        <HelpCenterRoute />
      </Route>
      <Route exact path={match.url}>
        <div>This is a private route from appV2</div>
      </Route>
      <Route path="*">
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
